import baseUrl from "@pocapan/shared/utils/baseUrl";
import getToken from "@pocapan/shared/utils/getToken";

export async function unlikeArtist(artistId: string) : Promise<boolean> {
  const response = await fetch(`${baseUrl()}/api/v1/artists/${artistId}/unlike`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    }
  });

  if (!response.ok) return false;
  
  return true;
}
